import React from 'react';
import { useState } from 'react';
import '../styles/message.css';
import '../styles/msgpolls.css';
import { notification } from 'antd';
import { useContext } from 'react';
import filterContext from '../context/filters/filterContext';
const Box = ({ option, msgId, indexopt, votes, votecount, oidx }) => {
	const { usersOfParticularGroup } = useContext(filterContext);
	const [voteLevel, setvoteLevel] = useState(0);
	const [count, setcount] = useState(0);
	const [len, setlen] = useState(usersOfParticularGroup.length);
	const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
	const handleVote = async () => {
		try {
			const requestBody = {
				messageId: msgId,
				optionIndex: oidx,
			};
			const response = await fetch(`${apiBaseUrl}/chats/votePoll`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					authorization: `Token ${window.localStorage.getItem('token')}`,
				},
				body: JSON.stringify(requestBody),
			});
			const responseData = await response.json();

			if (responseData.success) {
				if (voteLevel <= 200) {
					setvoteLevel(voteLevel + 200 / len);
					setcount(count + 1);
				} else {
					setvoteLevel(0);
				}
			} else {
				notification.error({ message: 'User has already voted' });
			}
		} catch (error) {
			console.log('Some error occurred');
		}
	};
	return (
		<>
			<div style={{ padding: '8px' }}>
				<span style={{ color: 'white' }}>{option}</span>
				<div
					style={{
						color: 'white',
						marginTop: '5px',
						display: 'flex',
						alignItems: 'center',
					}}
				>
					<section
						style={{
							width: '200px',
							height: '20px',
							backgroundColor: 'transparent',
							position: 'relative',
							cursor: 'pointer',
							overflow: 'hidden',
							border: '1px solid white',
							borderRadius: '10px',
							margin: '0px',
						}}
						onClick={handleVote}
					>
						<section
							style={{
								width:
									votecount === '0'
										? '0px'
										: parseInt(votecount) * (200 / len) + parseInt(voteLevel) + 'px',
								height: '20px',
								backgroundColor: 'green',
								position: 'absolute',
								bottom: 0,
								transition: 'width 0.5s',
								margin: '0px',
								padding: '0px',
								borderRadius: '10px',
							}}
						></section>
					</section>
					<span style={{ marginLeft: '10px', color: 'white' }}>
						{votecount + count}
					</span>
				</div>
			</div>
		</>
	);
};

export default Box;
